import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../Button';
import './styles.css';
import DropdownButton from '../DropdownButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer, IconButton, List, ListItem, ListItemText, Divider } from '@mui/material';
import Logo from '../../imgs/logo';
import { useIsMobile } from '../../hooks/useIsMobile';

const routes = [
  { label: 'Início', path: '/' },
  { label: 'Quem somos?', path: '/quem-somos' },
  { label: 'Fale conosco', path: '/fale-conosco' },
  {
    label: 'Jogos', submenu: [
      { label: 'Jogo da Memória', path: '/jogos/jogo-da-memoria' },
      { label: 'Flashcards', path: '/jogos/flashcards' },
      { label: 'Verdade ou Mentira', path: '/jogos/verdade-ou-mentira' }
    ]
  },
  {
    label: 'Saúde Bucal', submenu: [
      { label: 'Higienização Bucal', path: '/saude-bucal/higienizacao-bucal' },
      { label: 'Agravos Bucais', path: '/saude-bucal/agravos-bucais' },
      { label: 'Aparelhos', path: '/saude-bucal/aparelhos' },
      { label: 'Clareamento', path: '/saude-bucal/clareamentos' },
      { label: 'Siso', path: '/saude-bucal/siso' },
    ]
  },
  {
    label: 'Saúde Geral', submenu: [
      { label: 'Hábitos Saudáveis', path: '/saude-geral/habitos-saudaveis' },
      { label: 'Saúde Emocional', path: '/saude-bucal/saude-emocional' },
      { label: 'Saúde Sexual', path: '/saude-geral/problemas-dia-a-dia' },
    ]
  }
];

function Header() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => () => setDrawerOpen(open);

  const handleNavigate = (path) => {
    navigate(path);
    setDrawerOpen(false);
  };

  return (
    <>
      <div className={isMobile ? '' : 'header'}>
        <div className='mobile-menu'>
          <div style={{ position: 'fixed', top: 10, left: 10, width: '100%', zIndex: 999 }}>
            <IconButton
              style={{ borderRadius: 90, padding: 10, background: 'rgba(245, 248, 255, 0.65)' }}
              onClick={toggleDrawer(true)}
            >
              <MenuIcon width={30} />
            </IconButton>
          </div>
        </div>

        <div className='desktop-menu'>
          <div className='logo'>
            <Logo />
          </div>
          <div className='nav-links'>
            <Button onClick={() => navigate('/')}>Início</Button>
            <DropdownButton
              label="Saúde Bucal"
              options={routes.find(r => r.label === 'Saúde Bucal').submenu}
            />
            <DropdownButton
              label="Saúde Geral"
              options={routes.find(r => r.label === 'Saúde Geral').submenu}
            />
            <DropdownButton
              label="Jogos"
              options={routes.find(r => r.label === 'Jogos').submenu}
            />
            <Button onClick={() => navigate('/como-ser-atendido')}>Atendimento</Button>
            <Button onClick={() => navigate('/quem-somos')}>Quem Somos</Button>
            <Button
              primary
              onClick={() => window.open('https://www.fo.ufu.br/contact', '_blank')}
            >
              Fale Conosco
            </Button>
          </div>
        </div>
      </div>

      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <List sx={{ width: 250 }}>
          <ListItem>
            <Logo />
          </ListItem>
          <Divider />
          {routes.map((route) => {
            if (route.label === 'Fale conosco') {
              return (
                <ListItem
                  button
                  key={route.label}
                  onClick={() => {
                    window.open('https://www.fo.ufu.br/contact', '_blank');
                    setDrawerOpen(false);
                  }}
                >
                  <ListItemText primary={route.label} />
                </ListItem>
              );
            }

            return route.submenu ? (
              <div key={route.label}>
                <ListItemText primary={route.label} sx={{ pl: 2, pt: 1 }} />
                {route.submenu.map((sub) => (
                  <ListItem
                    button
                    key={sub.label}
                    onClick={() => handleNavigate(sub.path)}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary={sub.label} />
                  </ListItem>
                ))}
              </div>
            ) : (
              <ListItem
                button
                key={route.label}
                onClick={() => handleNavigate(route.path)}
              >
                <ListItemText primary={route.label} />
              </ListItem>
            );
          })}
        </List>
      </Drawer>
    </>
  );
}

export default Header;
